import { ProjectIndexRouteView } from './view';

export const indexRoute = {
  index: true,
  element: <ProjectIndexRouteView/>,
};